import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0B132B]/95 p-3 backdrop-blur-md md:hidden" data-testid="mobile-sticky-cta">
      <Link
        to="/contact"
        data-testid="mobile-sticky-cta-button"
        className="flex items-center justify-center gap-2 bg-[#0D9488] px-5 py-3.5 text-[13px] font-bold uppercase tracking-[0.14em] text-white"
      >
        START YOUR PROJECT
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
